// frontend/src/components/DocumentViewer/FallbackPreview.tsx

import React from "react";
import { FileText, ImageIcon } from "lucide-react";
import ViewerControls from "./ViewerControls";

interface FallbackPreviewProps {
  type: "pdf" | "image";
  message?: string;
  showControls?: boolean;
}

const FallbackPreview: React.FC<FallbackPreviewProps> = ({
  type,
  message = "Anteprima non disponibile",
  showControls = true,
}) => {
  const handleMockAction = () => {
    // Action not available in fallback mode
  };

  return (
    <div className="flex flex-col w-full h-full bg-gray-50">
      <div className="flex-1 flex items-center justify-center p-4 pb-0">
        <div className="w-full h-full bg-white rounded-lg shadow-sm flex items-center justify-center">
          <div className="flex flex-col items-center justify-center p-6 text-center">
            {type === "pdf" ? (
              <FileText size={64} className="text-gray-300 mb-6" />
            ) : (
              <ImageIcon size={64} className="text-gray-300 mb-6" />
            )}
            <div className="text-gray-500 font-medium">{message}</div>
          </div>
        </div>
      </div>

      {showControls && (
        <div className="h-12 border-t border-gray-200 flex items-center justify-center">
          <ViewerControls onFullscreen={handleMockAction} disabled={true} />
        </div>
      )}
    </div>
  );
};

export default FallbackPreview;
